import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import icons from './Icons';

const sizeMap = {
  xs: '1rem', // 16px
  sm: '1.25rem', // 20px
  md: '1.5rem', // 24px
  lg: '2rem', // 32px
  xl: '2.5rem', // 40px
};

export const Icon = forwardRef(
  ({ name, size = 'md', color, className = '', title, ...props }, ref) => {
    const IconComponent = icons[name];

    if (!IconComponent) {
      console.warn(`Icon '${name}' not found in icons:`, Object.keys(icons));
      return null;
    }

    const customSize = sizeMap[size] || size;
    const style = {
      width: customSize,
      height: customSize,
      ...(color && { fill: color }),
      ...props.style,
    };

    return (
      <IconComponent
        ref={ref}
        className={`icon ${className}`}
        style={style}
        role='img'
        aria-hidden={!title}
        aria-label={title}
        {...props}
      />
    );
  }
);

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    PropTypes.string,
  ]),
  color: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
};

Icon.displayName = 'Icon';
